import React, { ComponentProps } from "react";
import { Theme } from "@literati/public-ui-shared-react";
import StepLayout, {
  StepLayoutClassName,
  StepLayoutProps,
} from "components/Step/StepLayout";
import SubscriptionConfirmationPage from "components/checkout/SubscriptionConfirmationPage";
import styled from "styled-components";

const StyledStepLayout = styled(StepLayout)`
  .${StepLayoutClassName.CONTENT_SPACING} {
    width: 100vw;
    align-items: stretch;
  }
`;

export type StepLayoutPropsConfirmationSubscriptionPurchase = Omit<
  StepLayoutProps<object>,
  "asForm" | "children" | "formId"
>;

export type StepConfirmationSubscriptionPurchaseProps =
  StepLayoutPropsConfirmationSubscriptionPurchase &
    ComponentProps<typeof SubscriptionConfirmationPage>;

export const StepConfirmationSubscriptionPurchase = (
  props: StepConfirmationSubscriptionPurchaseProps
) => {
  return (
    <Theme>
      <StyledStepLayout
        asForm={false}
        bgColor="white"
        disableContentSpacing
        {...props}
      >
        <SubscriptionConfirmationPage {...props} />
      </StyledStepLayout>
    </Theme>
  );
};

export default StepConfirmationSubscriptionPurchase;
